<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex w-full items-center p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="w-12" src="images/logo/logo-ave-cut.png" />
      </div>
      <!-- Components -->
      <div class="ml-auto flex items-center">
        <notifications></notifications>
        <user [showAvatar]="false"></user>
      </div>
    </div>
    <!-- User
        <div class="flex w-full flex-col items-center p-4">
            <div class="relative h-24 w-24">
                @if (user.avatar) {
                    <img
                        class="h-full w-full rounded-full"
                        [src]="user.avatar"
                        alt="User avatar"
                    />
                }
                @if (!user.avatar) {
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_solid:user-circle'"
                    ></mat-icon>
                }
            </div>
            <div class="mt-6 flex w-full flex-col items-center justify-center">
                <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-center font-medium leading-normal"
                >
                    {{ user.name }}
                </div>
                <div
                    class="text-secondary mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-center text-md font-medium leading-normal"
                >
                    {{ user.email }}
                </div>
            </div>
        </div> -->
  </ng-container>
  <!-- Navigation footer hook -->
  <!-- <ng-container fuseVerticalNavigationContentFooter>
        <div
            class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12"
        >
            <img class="max-w-36" src="images/logo/logo-text-on-dark.svg" />
        </div>
    </ng-container> -->
</fuse-vertical-navigation>
<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card relative flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none print:hidde border-b"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')" class="m-[-10px]">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>

    @if(isActive){
    <div
      *ngIf="breadcrumbs().length"
      class="text-3xl font-extrabold tracking-tight"
    >
      {{ breadcrumbs()[breadcrumbs().length - 1].label }}
    </div>
    }
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      @if (
        (exportService.active$ | async) &&
        (exportService.busy$ | async) &&
        !(exportService.visible$ | async)
      ) {
        <button mat-button (click)="onExportButtonPressed()">
          <div class="flex items-center gap-2">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Exportando...</span>
          </div>
        </button>
      }
        <!-- <languages></languages>-->
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        <!--<search [appearance]="'bar'"></search>-->
        <search-page [appearance]="'bar'"></search-page>
        <shortcuts></shortcuts>
        
        <!-- Filter Button - Integrated in the topbar -->
        <button
          mat-icon-button 
          (click)="toggleFilter()"
          class="filter-toggle-btn">
          <mat-icon 
            svgIcon="heroicons_outline:funnel" 
            class="w-4 h-4">
          </mat-icon>
        </button>
        
        <!-- <messages></messages> -->
        <span class="w-[20px]"></span>
        <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button> -->
    </div>
  </div>

  <!-- <div
        class="bg-card flex flex-0 flex-col border-b p-6 dark:bg-transparent sm:flex-row sm:items-center sm:justify-between sm:px-10 sm:py-1"
    >        
        <div *ngFor="let breadcrumb of breadcrumbs()" class="ml-1 flex items-center whitespace-nowrap">
            <mat-icon
                class="text-secondary icon-size-5"
                [svgIcon]="'heroicons_mini:chevron-right'"
            ></mat-icon>
            <a [routerLink]="breadcrumb.url" class="ml-1 text-primary-500">{{ breadcrumb.label }}</a>
        </div>
        <div class="min-w-0 flex-1">
        </div>
    </div> -->
  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->